import { createPortal } from "react-dom";

export default function DeleteConfirmationModal({
  target,
  onCancel,
  onConfirmTournament,
  onConfirmRegistro,
}) {
  if (!target || typeof document === "undefined") return null;

  const label = target.type === "torneio" ? "torneio" : "registro";

  const handleConfirm = () => {
    if (target.type === "torneio") {
      onConfirmTournament(target.id);
      return;
    }

    onConfirmRegistro(target.id);
  };

  return createPortal(
    <div
      className="delete-modal-backdrop delete-modal-backdrop--prominent"
      role="presentation"
      onClick={onCancel}
    >
      <section
        className="delete-modal delete-modal--prominent"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="delete-modal-title" className="delete-modal__title">
          Remover {label}
        </h2>
        <p className="delete-modal__text">
          Tem certeza que deseja remover esse {label}?
        </p>
        <div className="delete-modal__actions">
          <button className="btn-ghost" type="button" onClick={onCancel}>
            Cancelar
          </button>
          <button className="btn-red" type="button" onClick={handleConfirm}>
            Remover
          </button>
        </div>
      </section>
    </div>,
    document.body
  );
}
